
export const actionTypes = {
    CREATE_EVENT: 'CREATE_EVENT',
    FETCH_EVENTS: 'FETCH_EVENTS',
    FETCH_RESULTS: 'FETCH_RESULTS',
    FETCH_EVENT: 'FETCH_EVENT',
    DELETE_EVENT: 'DELETE_EVENT',
    CLEAR_EVENT: 'CLEAR_EVENT',
    CLEAR_RESULTS: 'CLEAR_RESULTS',
    REG_FAILURE: 'REG_FAILURE',
    REG_SUCCESS: 'REG_SUCCESS',
    REG_START: 'REG_START',
    EDIT_EVENT:'EDIT_EVENT',
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    FETCH_WINNERS: 'FETCH_WINNERS'
}

export const FETCH_RESULTS = 'FETCH_RESULTS';

export const AUTH_START = 'AUTH_START';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';

export const AUTH_FAILURE = 'AUTH_FAILURE';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
